import React, { useContext, useEffect } from "react";
import { Box, Typography, Button } from '@mui/material';

import { useState } from "react";
import { useUrlContext } from '../context/urlContext';
//import BasicTable from "../Components/BasicReactTable";

import ParentComponent from "../Components/ParentForTableAndFormComponent";
import axios from "axios";
import RedemptionPartnerForm from "../Forms/RedemptionPartnerForm";
import { date } from "yup";
import { errorContext } from "../Components/ErrorDisplay";
import { useConfirm } from "../Components/ConfirmDialog";
import { useAuth } from '../context/authContext';
import { useHistory } from 'react-router-dom';


function RedemptionPartner(props) {
    const { UrlHelperObj } = useUrlContext();
    const { user } = useAuth();
    const history = useHistory();
    const [columnInfo, setColumnInfo] = useState([
        {title: 'Name','dbname':'name'},
        {title:'Contacts',dbname:'key_contacts'},
    ]);
    const[rpartnerRecords,setRpartnerRecords]=useState([]);
    const {handleError} = useContext(errorContext);
    const confirm = useConfirm();
    

    async function getRPartnerRecords()
    {
        if (!user?.issuerId) {
            setRpartnerRecords([]);
            return;
        }
        await axios.get(UrlHelperObj.rpartnerUrl_GET(user.issuerId))
        .then(response => response.data)
        .then(results => setRpartnerRecords(results))
        .catch(err => handleError(err));
    }
    async function deleteRPartnerRecord(record)
    {
        const ok = await confirm({ title: 'Delete redemption partner', message: 'Are you sure you want to delete this redemption partner?', confirmText: 'Delete' });
        if (!ok) {
            return;
        }
        await axios.delete(UrlHelperObj.rpartnerUrlById(record))
        .then(response => response.data)
        .then(results =>console.log("delete of Partner "+record+" successful"))
        .catch(err => handleError(err));
        getRPartnerRecords();
    }
    async function editRPartnerRecord(record)
    {
        const data ={
            id:record.id,
            issuer_id:user?.issuerId,
            name:record.redemptionPartnerName,
            key_contacts:record.contact

        }

        console.log("Partner edit"+JSON.stringify(record));
        await axios.put(UrlHelperObj.rpartnerUrl(),data)
        .then(response => response.data)
        .then(results =>console.log("Edit of RPartner "+record+" successful"))
        .catch(err => handleError(err));
        getRPartnerRecords();
    }
    async function addRPartnerRecord(record)
    {
        const data ={
            id:0,
            issuer_id:user?.issuerId,
            name:record.redemptionPartnerName,
            key_contacts:record.contact

        }
        await axios.post(UrlHelperObj.rpartnerUrl(),data)
        .then(response => response.data)
        .then(results =>console.log("Add of RPartner "+record+" successful"))
        .catch(err => handleError(err));
        getRPartnerRecords();
    }
    useEffect(() =>{
        //setTableFlag(true);
        getRPartnerRecords();
    },[user?.issuerId])

    function handleFormSubmit(data,isAddOperation,isCancelOperation)
    {
        if (typeof props.setFormShown === 'function') {
            props.setFormShown(false);
        }
        if(isCancelOperation === true)
        {
            console.log("Cancelled operation");
            return 0;
        }
        console.log("handleFormSubmit"+data+"-add-operation-"+isAddOperation);
        if(isAddOperation === true)
            addRPartnerRecord(data);
        else
            editRPartnerRecord(data);
    }

    return(
        <Box>
            <Typography variant="h5" style={{ color: 'black', textAlign: 'left', marginBottom: 12 }}>
                Redemption Partners
            </Typography>
            <ParentComponent 
            data={rpartnerRecords}
            columns={columnInfo}
            form={RedemptionPartnerForm}
            formTitle={"Redemption Partner"}
            handleFormSubmitFunc={handleFormSubmit}
            setFormShownFlag={props.setFormShown}
            alreadySelectedOwnRow={props.alreadySelectedOwnRow}
            deleteFunc={deleteRPartnerRecord}
            setSelectedRow={props.setSelectedRow}
            isAddDisabled={false}
            />
        </Box>
    );
            
}
export default RedemptionPartner;